import React from 'react';
import { observer } from 'mobx-react';
import { convertLoomShareToEmbed } from '~/utils/url.utils';
import { VIDEO_PLAYER_CLASS } from '~/common/id.constants';
import { trackError } from '~/services/logger/error.utils';
import { IframeVideo } from '~/common/VideoPlayer/IframeVideo';

const DEFAULT_LOOM_PARAMS =
    '?hide_owner=true&hide_share=true&hide_title=true&hideEmbedTopBar=true';

type LoomVideoProps = {
    isAutoplayOn?: boolean;
    onError: () => void;
    onReady: () => void;
    videoLink: string;
};

const LoomVideo = ({
    isAutoplayOn,
    onError,
    onReady,
    videoLink
}: LoomVideoProps) => {
    let embedUrl = convertLoomShareToEmbed(videoLink);

    if (!embedUrl) {
        trackError({
            error: new Error('Invalid Loom share link'),
            context: { shareLink: videoLink }
        });
    }

    embedUrl += DEFAULT_LOOM_PARAMS;
    embedUrl += isAutoplayOn ? '&autoplay=1' : '';

    return (
        <IframeVideo
            className={VIDEO_PLAYER_CLASS}
            onError={onError}
            onReady={onReady}
            videoLink={embedUrl}
            title="loom embed"
        />
    );
};

export default observer(LoomVideo);
